export default "__VITE_ASSET__9d7ce9d9__"